import { TranscricaoDetalhe } from '../../../../interfaces/entities/Transcricao/TranscricaoDetalhe';
import { TranscricaoItemDetalhe } from '../../../../interfaces/entities/Transcricao/TranscricaoRevisao';
import { TranscricaoAnexo } from '../transcricaoTypes';

export enum TranscricaoStepEnum {
  Anexos = 1,
  Transcricao = 2,
}

export type RevisaoStatus = 'idle' | 'carregando' | 'em_andamento' | 'pronta' | 'erro';

export type OrigemRevisao = 'aposSalvar' | 'continuarRascunho' | null;

export type { TranscricaoAnexo };

export interface TranscricaoState {
  currentStep: TranscricaoStepEnum;
  anexos: TranscricaoAnexo[];
  validandoAnexo: boolean;
  termosAceitos: boolean;
  dataAceite: string | null;
  idTranscricao: string | null;
  origemRevisao: OrigemRevisao;
  revisaoStatus: RevisaoStatus;
  procedimentos: TranscricaoItemDetalhe[];
  detalheTranscricao: TranscricaoDetalhe | null;
}

export type TranscricaoAction =
  | { type: 'SET_STEP'; payload: TranscricaoStepEnum }
  | { type: 'SET_ANEXOS'; payload: TranscricaoAnexo[] }
  | { type: 'SET_VALIDANDO_ANEXO'; payload: boolean }
  | { type: 'SET_TERMOS_ACEITOS'; payload: boolean }
  | { type: 'SET_DATA_ACEITE'; payload: string | null }
  | { type: 'SET_ID_TRANSCRICAO'; payload: string | null }
  | { type: 'SET_ORIGEM_REVISAO'; payload: OrigemRevisao }
  | { type: 'SET_REVISAO_STATUS'; payload: RevisaoStatus }
  | { type: 'SET_PROCEDIMENTOS'; payload: TranscricaoItemDetalhe[] }
  | { type: 'UPDATE_PROCEDIMENTO'; payload: TranscricaoItemDetalhe }
  | { type: 'SET_DETALHE_TRANSCRICAO'; payload: TranscricaoDetalhe | null }
  | { type: 'RESET' };
